import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import RecordsForm from './recordForm';

const RedPacketRecordsList = () => {
  const translate = useTranslate();
  return (
    <PermissionGuard resource="redpacket" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('module.redpacket.distributionRecord')}
          links={[
          { name: translate('module.redpacket.redPacketManagement'), href: `/${Resources.redpacket}` },
          { name: translate('module.redpacket.distributionRecord') },
        ]}
        />
        <RecordsForm />
      </DashboardContent>
    </PermissionGuard>
  );
};

export default RedPacketRecordsList;
